import React, { useState, useEffect, useCallback } from 'react';
import EICheckBox, {
  EISelectBox,
  UnitTextBox,
} from 'components/customComponents/Layers/EICheckBox';

import LayersHeading from 'components/customComponents/Layers/LayersHeading';
import ELayersView, { EGridVaryAlong, ELayersDefaultInput } from 'enums/ELayersView';
import { EditIngredientProps, SelectNameValue } from 'business/models/CustomModels';
import {
  ConditionIngredientDTO,
  CustomLayerDTO,
  ConcentrationVaryAlongCustomDTO,
  GridIngredientDTO,
  GridLayerDTO,
  LayerDTO,
  LayerTypeDTO,
  RandomLayerDTO,
  RandomLayerGroupIngredientDTO,
  WellIngDTO,
  PhVaryAlongCustomDTO,
} from 'business/models/Models';
import {
  getIngNameByIngId,
  GetIngredients,
  getIngredientStock,
  getStockConcVendor,
  getNewId,
  isNullOrUndefined,
  getIngIngType,
  isBufferIngredientById,
  getAllIngredientStocks,
  roundStringValue,
  checkIsValidInput,
  setRoundedValue,
  showAlertSnackBar,
} from 'utils/Global';
import { usePreserveExperiment, useRMDispatch, useRMSelector } from 'redux/hooks';
import RMButton from 'components/customComponents/Controls/RMButton';
import LayersError from 'components/customComponents/Layers/LayersError';
import { getLinkedLayerGridDto } from 'business/plateviewer/GenerateUtil';
import { dirtifyOverLappingLayers } from 'business/plateviewer/layer/ResizeLayerTools';
import RMModal from 'components/modal/RMModal';
import Spreadsheet from 'react-spreadsheet';
import { findWellsInLayer } from 'business/plateviewer/Generate/GenerateCommon';
import {
  selectExp,
  selectExperimentLayers,
  selectSelectedLayerId,
} from 'redux/selectors/ExperimentStateSelector';
import { updateExperimentLayers } from 'redux/reducers/experimentDataReducer';
import { cloneDeep } from 'lodash';
import { withTabBackButton } from 'components/tab';
import { FmlxButton } from 'fmlx-common-ui';
import EAlertType from 'enums/EAlertType';
import ESnackBarPosition from 'enums/ESnackBarPosition';

function EditIngredients(props: EditIngredientProps) {
  const {
    setContentView,
    selectStock,
    selectIngredient,
    editIngredientData = {},
    selectHighPHStock,
    resetStockValue,
    setHandleOnTabBackPress,
    handleBackToPreviousScreen,
    setSelectedTab,
  } = props;
  const _layers = useRMSelector(selectExperimentLayers);
  const _selectedLayerId = useRMSelector(selectSelectedLayerId);
  const _selectedLayer = _layers.find((l) => l.id === _selectedLayerId);
  const exp = useRMSelector(selectExp);

  const [stockData, setStockData] = useState(
    getIngredientStock(editIngredientData.ingredientStockId),
  );
  const [highPhStock, setHighPhStock] = useState(
    getIngredientStock(editIngredientData.highPhingredientStockId),
  );
  const selectIngIngType = getIngIngType(selectIngredient.id);
  const [weightValue, setWeightValue] = useState(editIngredientData.weight);
  const [startConcentration, setStartConcentration] = useState(
    roundStringValue(editIngredientData.startConcentration).toString(),
  );
  const [stopConcentration, setStopConcentration] = useState(
    roundStringValue(editIngredientData.stopConcentration).toString(),
  );
  const [phStartValue, setphStartValue] = useState(
    _selectedLayer?.type === LayerTypeDTO.Grid
      ? roundStringValue(editIngredientData.startpH).toString()
      : roundStringValue(editIngredientData.lowPh).toString(),
  );
  const [customPhValue, setCustomPhValue] = useState(
    roundStringValue(editIngredientData.pH).toString(),
  );
  const [phStopValue, setphStopValue] = useState(
    _selectedLayer?.type === LayerTypeDTO.Grid
      ? roundStringValue(editIngredientData.stoppH).toString()
      : roundStringValue(editIngredientData.highPh).toString(),
  );
  const [lowConcentration, setLowConcentration] = useState(
    roundStringValue(editIngredientData.lowConcentration).toString(),
  );
  const [highConcentration, setHighConcentration] = useState(
    roundStringValue(
      !isNullOrUndefined(editIngredientData.highConcentration) &&
        editIngredientData.highConcentration.toString(),
    ),
  );
  const [error, setError] = useState<boolean>(false);
  const [lowPhError, setLowPhError] = useState<boolean>(false);
  const [highPhError, setHighPhError] = useState<boolean>(false);
  const [highConcError, setHighConcError] = useState<boolean>(false);
  const [weightError, setWeightError] = useState<boolean>(false);
  const [selectIngredientType, setSelectIngredientType] = useState(0);
  const [customLayerConcentration, setCustomLayerConcentration] = useState(
    roundStringValue(editIngredientData.concentration).toString(),
  );
  const [concentrationVaryAlong, setConcentrationVaryAlong] = useState(
    !editIngredientData.concentrationVaryAlong
      ? EGridVaryAlong.NONE
      : editIngredientData.concentrationVaryAlong,
  );

  const [
    showConcentrationVaryAlongCustomButton,
    setShowConcentrationVaryAlongCustomButton,
  ] = useState(concentrationVaryAlong === EGridVaryAlong.CUSTOM);

  const [
    showEditConcentrationVaryAlongCustomValuesModal,
    setShowEditConcentrationVaryAlongCustomValuesModal,
  ] = useState(false);

  const [showEditPhVaryAlongCustomValuesModal, setShowEditPhVaryAlongCustomValuesModal] =
    useState(false);

  const [
    concentrationVaryAlongCustomSpreadSheetData,
    setConcentrationVaryAlongCustomSpreadSheetData,
  ] = useState([]);

  const [phVaryAlongCustomSpreadSheetData, setPhVaryAlongCustomSpreadSheetData] =
    useState([]);

  const [phVaryAlong, setPhVaryAlong] = useState(
    !editIngredientData.pHvaryAlong
      ? EGridVaryAlong.NONE
      : editIngredientData.pHvaryAlong,
  );

  const [showPhVaryAlongCustomButton, setShowPhVaryAlongCustomButton] = useState(
    phVaryAlong === EGridVaryAlong.CUSTOM,
  );

  const [ingredientName, setIngredientName] = useState(
    isNullOrUndefined(stockData)
      ? ELayersDefaultInput.SELECTINGREDIENT
      : getIngNameByIngId(stockData.ingredientId),
  );
  const [ingredientTypes, setIngredientTypes] = useState([]);
  const gridVaryAlong: SelectNameValue[] = [
    { name: 'None', value: EGridVaryAlong.NONE },
    { name: 'Rows', value: EGridVaryAlong.ROW },
    { name: 'Columns', value: EGridVaryAlong.COLUMN },
    { name: 'Linked Layers', value: EGridVaryAlong.LINKEDLAYER },
    { name: 'Well Numbers', value: EGridVaryAlong.WELLNUMBER },
    { name: 'Custom', value: EGridVaryAlong.CUSTOM },
  ];

  const [concentrationVaryAlongCustomValues, setConcentrationVaryAlongCustomValues] =
    useState([]);

  const [phVaryAlongCustomValues, setPhVaryAlongCustomValues] = useState([]);

  const [
    showOverrideConcentrationVaryAlongCustomSpreadSheetWarning,
    setShowOverrideConcentrationVaryAlongCustomSpreadSheetWarning,
  ] = useState(false);

  const [
    showOverridePhVaryAlongCustomSpreadSheetWarning,
    setShowOverridePhVaryAlongCustomSpreadSheetWarning,
  ] = useState(false);

  const [
    isConcentrationVaryAlongCustomSpreadSheetEdited,
    setIsConcentrationVaryAlongCustomSpreadSheetEdited,
  ] = useState(false);
  const [isPhVaryAlongCustomSpreadSheetEdited, setIsPhVaryAlongCustomSpreadSheetEdited] =
    useState(false);

  const dispatch = useRMDispatch();
  const _setLayers = useCallback(
    (lyrs: LayerDTO[]) => dispatch(updateExperimentLayers(lyrs)),
    [dispatch],
  );
  const callPreserveUndoableState = usePreserveExperiment();

  useEffect(() => {
    if (!isNullOrUndefined(selectStock)) {
      setStockData(selectStock);

      if (editIngredientData?.ingredientStockId === selectStock.id) {
        return;
      }

      setCustomLayerConcentration(
        !isNullOrUndefined(selectStock.lowConcentration) &&
          selectStock.lowConcentration.toFixed(3),
      );
      setLowConcentration(
        !isNullOrUndefined(selectStock.lowConcentration) &&
          selectStock.lowConcentration.toFixed(3),
      );
      setHighConcentration(
        !isNullOrUndefined(selectStock.highConcentration) &&
          selectStock.highConcentration.toFixed(3),
      );
      setStartConcentration(
        !isNullOrUndefined(selectStock.lowConcentration) &&
          selectStock.lowConcentration.toFixed(3),
      );
      setStopConcentration(
        !isNullOrUndefined(selectStock.highConcentration) &&
          selectStock.highConcentration.toFixed(3),
      );
      setphStartValue(
        !isNullOrUndefined(selectStock.stockPh) && selectStock.stockPh.toFixed(3),
      );
      setphStopValue(
        !isNullOrUndefined(selectStock.stockPh) && selectStock.stockPh.toFixed(3),
      );
      setCustomPhValue(
        !isNullOrUndefined(selectStock.stockPh) && selectStock.stockPh.toFixed(3),
      );
      setPhVaryAlong(EGridVaryAlong.NONE);
      setConcentrationVaryAlong(EGridVaryAlong.NONE);
    }
  }, [selectStock]);
  useEffect(() => {
    getIngredientTypes();
  }, [stockData]);
  useEffect(() => {
    if (!isNullOrUndefined(selectHighPHStock)) {
      setHighPhStock(selectHighPHStock);

      setphStopValue(selectHighPHStock.stockPh);
    }
  }, [selectHighPHStock]);

  useEffect(() => {
    setIngredientName(selectIngredient.name);
  }, [selectIngredient]);

  useEffect(() => {
    if (concentrationVaryAlong == EGridVaryAlong.CUSTOM) {
      setShowConcentrationVaryAlongCustomButton(true);
    } else {
      setShowConcentrationVaryAlongCustomButton(false);
    }
  }, [concentrationVaryAlong]);

  useEffect(() => {
    if (phVaryAlong == EGridVaryAlong.CUSTOM) {
      setShowPhVaryAlongCustomButton(true);
    } else {
      setShowPhVaryAlongCustomButton(false);
    }
  }, [phVaryAlong]);

  useEffect(() => {
    try {
      const value = (
        _selectedLayer?.layerDetail as GridLayerDTO
      ).grid.gridIngredient.find(
        (gi) => gi.ingredientIngredientTypeId == selectIngredient.id,
      ).concentrationVaryAlongCustom.concentrationVaryAlongCustomValues;
      setConcentrationVaryAlongCustomValues(value);
    } catch {
      setConcentrationVaryAlongCustomValues([]);
    }

    setConcentrationVaryAlong(
      !editIngredientData.concentrationVaryAlong
        ? EGridVaryAlong.NONE
        : editIngredientData.concentrationVaryAlong,
    );

    setPhVaryAlong(
      !editIngredientData.pHvaryAlong
        ? EGridVaryAlong.NONE
        : editIngredientData.pHvaryAlong,
    );
  }, []);

  useEffect(() => {
    try {
      const value = (_selectedLayer.layerDetail as GridLayerDTO).grid.gridIngredient.find(
        (gi) => gi.ingredientIngredientTypeId == selectIngredient.id,
      ).pHVaryAlongCustom.pHVaryAlongCustomValues;
      setPhVaryAlongCustomValues(value);
    } catch {
      setPhVaryAlongCustomValues([]);
    }
  }, []);

  useEffect(() => {
    setHandleOnTabBackPress(() =>
      handleBackToPreviousScreen(ELayersView.LAYERDESIGNVIEW),
    );
  }, [setHandleOnTabBackPress]);

  function handleStartConcentration(e) {
    let concValue = e.target.value;
    const isValid = checkIsValidInput(concValue);
    if (concValue == '.') {
      concValue = '0.';
    }
    if (isValid) {
      setRoundedValue(concValue, setStartConcentration);
      if (concValue > stockData.stockConcentration || e.target.value === '') {
        setError(true);
      } else {
        setError(false);
      }
    }
  }
  function handleCustomLayerConcentration(e) {
    let concValue = e.target.value;
    const isValid = checkIsValidInput(concValue);
    if (concValue == '.') {
      concValue = '0.';
    }
    if (isValid) {
      setRoundedValue(concValue, setCustomLayerConcentration);
      if (concValue > stockData.stockConcentration || e.target.value === '') {
        setError(true);
      } else {
        setError(false);
      }
    }
  }
  function handleStopConcentration(e) {
    let concValue = e.target.value;
    const isValid = checkIsValidInput(concValue);
    if (concValue == '.') {
      concValue = '0.';
    }
    if (isValid) {
      setRoundedValue(concValue, setStopConcentration);

      if (concValue > stockData.stockConcentration || e.target.value === '') {
        setHighConcError(true);
      } else {
        setHighConcError(false);
      }
    }
  }
  function handlephStartValue(e) {
    let phValue = e.target.value;
    const isValid = checkIsValidInput(phValue);
    if (phValue == '.') {
      phValue = '0.';
    }
    if (isValid) {
      setRoundedValue(phValue, setphStartValue);
      if (isNullOrUndefined(highPhStock)) {
        if (phValue != stockData.stockPh) {
          setLowPhError(true);
        } else {
          setLowPhError(false);
        }
      } else {
        if (phValue < stockData.stockPh || phValue > highPhStock.stockPh) {
          setLowPhError(true);
        } else {
          setLowPhError(false);
        }
      }
    }
  }
  function handleCustomPhValue(e) {
    let phValue = e.target.value;
    const isValid = checkIsValidInput(phValue);
    if (phValue == '.') {
      phValue = '0.';
    }
    if (isValid) {
      setRoundedValue(phValue, setCustomPhValue);
      if (isNullOrUndefined(highPhStock)) {
        if (phValue != stockData.stockPh) {
          setLowPhError(true);
        } else {
          setLowPhError(false);
        }
      } else {
        if (phValue < stockData.stockPh || phValue > highPhStock.stockPh) {
          setLowPhError(true);
        } else {
          setLowPhError(false);
        }
      }
    }
  }
  function onSelectStock() {
    const stocks = getAllIngredientStocks(selectIngredient.id);
    setHighPhStock(null);
    resetStockValue();
    if (stocks.length >= 1) {
      setContentView(ELayersView.SELECTSTOCKSVIEW);
    }
  }
  function handlephStopValue(e) {
    let phValue = e.target.value;
    const isValid = checkIsValidInput(phValue);
    if (phValue == '.') {
      phValue = '0.';
    }
    if (isValid) {
      setRoundedValue(phValue, setphStopValue);
      if (isNullOrUndefined(highPhStock)) {
        if (phValue != stockData.stockPh) {
          setHighPhError(true);
        } else {
          setHighPhError(false);
        }
      } else if (phValue > highPhStock.stockPh || phValue < stockData.stockPh) {
        setHighPhError(true);
      } else {
        setHighPhError(false);
      }
    }
  }

  function changeConcentrationVaryAlong(e) {
    const val = Number(e.target.value);
    setConcentrationVaryAlong(val);
    if (selectStock?.stockConcentration < Number(stopConcentration)) {
      if (val != EGridVaryAlong.NONE) {
        setHighConcError(true);
      }
    }
  }
  function changepHVaryAlong(e) {
    setPhVaryAlong(Number(e.target.value));
  }
  function changeIngredientType(e) {
    setSelectIngredientType(Number(e.target.value));
  }

  function isEditIngError() {
    return (
      error ||
      lowPhError ||
      highConcError ||
      highPhError ||
      (isNullOrUndefined(highPhStock) && phVaryAlong !== EGridVaryAlong.NONE) ||
      weightError
    );
  }
  function handleLowConcentration(e) {
    let concValue = e.target.value;
    editIngredientData.lowConcentration = concValue;
    let isValid = checkIsValidInput(concValue);
    if (concValue == '.') {
      concValue = '0.';
    }
    if (isValid) {
      setRoundedValue(concValue, setLowConcentration);
      if (
        parseFloat(concValue) > parseFloat(highConcentration) ||
        e.target.value === '' ||
        parseFloat(concValue) > stockData.stockConcentration
      ) {
        setError(true);
      } else {
        setError(false);
      }
    }
    isValid = checkIsValidInput(highConcentration);
    if (isValid) {
      if (
        parseFloat(concValue) < parseFloat(highConcentration) &&
        parseFloat(highConcentration) <= stockData.stockConcentration
      ) {
        setHighConcError(false);
      }
    }
  }
  function handleHighConcentration(e) {
    let concValue = e.target.value;
    editIngredientData.highConcentration = concValue;
    let isValid = checkIsValidInput(concValue);
    if (concValue == '.') {
      concValue = '0.';
    }
    if (isValid) {
      setRoundedValue(concValue, setHighConcentration);
      if (
        parseFloat(concValue) < parseFloat(lowConcentration) ||
        e.target.value === '' ||
        parseFloat(concValue) > stockData.stockConcentration
      ) {
        setHighConcError(true);
      } else {
        setHighConcError(false);
      }
    }
    isValid = checkIsValidInput(lowConcentration);
    if (isValid) {
      if (
        parseFloat(lowConcentration) < parseFloat(concValue) &&
        parseFloat(lowConcentration) <= stockData.stockConcentration
      ) {
        setError(false);
      }
    }
  }
  function handleWeightValue(e) {
    if (!_selectedLayer) {
      return;
    }
    let weightVal = e.target.value;
    const isValid = checkIsValidInput(weightVal);
    if (weightVal == '.') {
      weightVal = '0.';
    }
    if (weightVal === '' || parseFloat(weightVal) === 0 || !isValid) {
      setWeightError(true);
    } else {
      setWeightError(false);
    }
    setRoundedValue(weightVal, setWeightValue);
  }
  function applyIngredientData(tempLayers: LayerDTO[]) {
    if (!_selectedLayer) {
      return;
    }
    const ingIngType = GetIngredients().ingredientIngredientType.find(
      (ingingtype) =>
        ingingtype.ingredientId === selectIngIngType.ingredientId &&
        selectIngredientType === ingingtype.ingredientTypeId,
    );
    let selectedLayerDetails;
    if (_selectedLayer.type === LayerTypeDTO.Grid) {
      selectedLayerDetails = cloneDeep(_selectedLayer.layerDetail) as GridLayerDTO;
      const gridDto = getLinkedLayerGridDto(tempLayers, selectedLayerDetails);
      if (selectedLayerDetails.subGridNumber === 1) {
        selectedLayerDetails.grid = gridDto;
      }
      if (isNullOrUndefined(editIngredientData.id)) {
        const gridIngredient: GridIngredientDTO = new GridIngredientDTO({
          id: getNewId(),
          gridId: gridDto.id,
          ingredientIngredientTypeId: ingIngType.id,
          ingredientStockId: stockData.id,
          highPhingredientStockId: isNullOrUndefined(highPhStock) ? null : highPhStock.id,
          startConcentration:
            startConcentration.length === 0 ? 0 : parseFloat(startConcentration),
          stopConcentration: parseFloat(stopConcentration),
          concentrationVaryAlong: concentrationVaryAlong,
          startpH: parseFloat(phStartValue),
          stoppH: parseFloat(phStopValue),
          pHvaryAlong: phVaryAlong,
        });
        if (isNullOrUndefined(gridDto.gridIngredient)) {
          gridDto.gridIngredient = [];
          gridDto.gridIngredient.push(gridIngredient);
          const layersCpy = tempLayers;
          const deleteIndex = layersCpy.findIndex(
            (layer) => layer.id === _selectedLayerId,
          );
          layersCpy.splice(deleteIndex, 1);
          if (deleteIndex != -1) {
            layersCpy.push(_selectedLayer);
            dispatch(updateExperimentLayers(layersCpy));
          }
        } else {
          gridIngredient.concentrationVaryAlongCustom =
            new ConcentrationVaryAlongCustomDTO();
          gridIngredient.concentrationVaryAlongCustom.id = getNewId();
          gridIngredient.concentrationVaryAlongCustom.concentrationVaryAlongCustomValues =
            concentrationVaryAlongCustomValues;
          setIsConcentrationVaryAlongCustomSpreadSheetEdited(false);

          gridIngredient.pHVaryAlongCustom = new PhVaryAlongCustomDTO();
          gridIngredient.pHVaryAlongCustom.id = getNewId();
          gridIngredient.pHVaryAlongCustom.pHVaryAlongCustomValues =
            phVaryAlongCustomValues;
          setIsPhVaryAlongCustomSpreadSheetEdited(false);

          gridDto.gridIngredient.push(gridIngredient);
        }
      } else {
        const updateGIIndex = gridDto.gridIngredient.findIndex(
          (gi) => gi.id === editIngredientData.id,
        );
        gridDto.gridIngredient[updateGIIndex].ingredientIngredientTypeId = ingIngType.id;
        gridDto.gridIngredient[updateGIIndex].ingredientStockId = stockData.id;
        gridDto.gridIngredient[updateGIIndex].highPhingredientStockId = isNullOrUndefined(
          highPhStock,
        )
          ? null
          : highPhStock.id;
        gridDto.gridIngredient[updateGIIndex].startConcentration =
          startConcentration.length === 0 ? 0 : parseFloat(startConcentration);
        gridDto.gridIngredient[updateGIIndex].stopConcentration =
          parseFloat(stopConcentration);
        gridDto.gridIngredient[updateGIIndex].concentrationVaryAlong =
          concentrationVaryAlong;
        gridDto.gridIngredient[updateGIIndex].startpH = parseFloat(phStartValue);
        gridDto.gridIngredient[updateGIIndex].stoppH = parseFloat(phStopValue);
        gridDto.gridIngredient[updateGIIndex].pHvaryAlong = phVaryAlong;

        gridDto.gridIngredient[updateGIIndex].concentrationVaryAlongCustom =
          new ConcentrationVaryAlongCustomDTO();
        gridDto.gridIngredient[updateGIIndex].concentrationVaryAlongCustom.id =
          getNewId();
        gridDto.gridIngredient[
          updateGIIndex
        ].concentrationVaryAlongCustom.concentrationVaryAlongCustomValues =
          concentrationVaryAlongCustomValues;
        setIsConcentrationVaryAlongCustomSpreadSheetEdited(false);

        gridDto.gridIngredient[updateGIIndex].pHVaryAlongCustom =
          new PhVaryAlongCustomDTO();
        gridDto.gridIngredient[updateGIIndex].pHVaryAlongCustom.id = getNewId();
        gridDto.gridIngredient[updateGIIndex].pHVaryAlongCustom.pHVaryAlongCustomValues =
          phVaryAlongCustomValues;
        setIsConcentrationVaryAlongCustomSpreadSheetEdited(false);
      }

      tempLayers.map((lyr) => {
        if (
          lyr.type == LayerTypeDTO.Grid &&
          (lyr.layerDetail as GridLayerDTO).gridId ==
            (_selectedLayer.layerDetail as GridLayerDTO).gridId
        ) {
          lyr.dirty = true;
        }
      });
    } else if (_selectedLayer.type === LayerTypeDTO.ConditionList) {
      selectedLayerDetails = cloneDeep(_selectedLayer.layerDetail) as CustomLayerDTO;
      let conditionIngredient: ConditionIngredientDTO;
      if (isNullOrUndefined(editIngredientData.id)) {
        conditionIngredient = new ConditionIngredientDTO({
          conditionId: editIngredientData.conditionId,
          ingredientIngredientTypeId: ingIngType.id,
          ingredientStockId: stockData.id,
          id: getNewId(),
          concentration:
            customLayerConcentration.length === 0
              ? 0
              : parseFloat(customLayerConcentration),
          highPhingredientStockId: isNullOrUndefined(highPhStock) ? null : highPhStock.id,
          pH: parseFloat(customPhValue),
        });
        selectedLayerDetails.condition
          .find((cdn) => cdn.id === editIngredientData.conditionId)
          .conditionIngredient.push(conditionIngredient);
      } else {
        conditionIngredient = selectedLayerDetails.condition
          .find((cdn) => cdn.id === editIngredientData.conditionId)
          .conditionIngredient.find((ing) => ing.id === editIngredientData.id);

        conditionIngredient.ingredientIngredientTypeId = ingIngType.id;
        conditionIngredient.ingredientStockId = stockData.id;
        conditionIngredient.concentration =
          customLayerConcentration.length === 0
            ? 0
            : parseFloat(customLayerConcentration);
        conditionIngredient.highPhingredientStockId = isNullOrUndefined(highPhStock)
          ? null
          : highPhStock.id;
        conditionIngredient.pH = parseFloat(customPhValue);
      }
    }
    handleBackToPreviousScreen(ELayersView.LAYERDESIGNVIEW)();
    resetStockValue();
    const tempSelectedLyrIndex = tempLayers.findIndex(
      (lyr) => lyr.id === _selectedLayerId,
    );
    tempLayers[tempSelectedLyrIndex] = cloneDeep(tempLayers[tempSelectedLyrIndex]);
    tempLayers[tempSelectedLyrIndex].dirty = true;
    tempLayers[tempSelectedLyrIndex].layerDetail = selectedLayerDetails;
  }

  function applyIngredientInRandomLayer(tempLayers: LayerDTO[]) {
    const tempLayerIndex = tempLayers.findIndex((lyr) => lyr.id === _selectedLayerId);
    const tempLayer = tempLayers[tempLayerIndex];
    if (isNullOrUndefined(editIngredientData.id)) {
      const ingIngType = GetIngredients().ingredientIngredientType.find(
        (ingingtype) =>
          ingingtype.ingredientId === stockData.ingredientId &&
          selectIngredientType === ingingtype.ingredientTypeId,
      );
      const ing: RandomLayerGroupIngredientDTO = new RandomLayerGroupIngredientDTO();

      ing.randomLayerIngredientGroupId = editIngredientData.randomLayerIngredientGroupId;
      ing.id = getNewId();
      ing.ingredientStockId = stockData.id;
      ing.ingredientIngredientTypeId = ingIngType.id;
      ing.highConcentration = parseFloat(highConcentration);
      ing.lowConcentration = parseFloat(lowConcentration);
      ing.weight = parseFloat(weightValue);

      if (isBufferIngredientById(selectIngIngType.ingredientTypeId)) {
        ing.highPhingredientStockId = isNullOrUndefined(highPhStock)
          ? null
          : highPhStock.id;

        ing.highPh = isNullOrUndefined(phStopValue) ? null : parseFloat(phStopValue);
        ing.lowPh = isNullOrUndefined(phStartValue) ? null : parseFloat(phStartValue);
      } else {
        ing.highPhingredientStockId = undefined;
        ing.highPh = undefined;
        ing.lowPh = undefined;
      }
      (tempLayer.layerDetail as RandomLayerDTO).randomLayerIngredientGroup
        .find((rlig) => rlig.id === editIngredientData.randomLayerIngredientGroupId)
        .randomLayerGroupIngredient.push(ing);
    } else {
      const ingIngType = GetIngredients().ingredientIngredientType.find(
        (ingingtype) =>
          ingingtype.ingredientId === stockData.ingredientId &&
          selectIngredientType === ingingtype.ingredientTypeId,
      );
      const randomDetails: RandomLayerDTO = tempLayer.layerDetail as RandomLayerDTO;

      const ing = randomDetails.randomLayerIngredientGroup
        .find((group) => group.id === editIngredientData.randomLayerIngredientGroupId)
        .randomLayerGroupIngredient.find((ing) => ing.id === editIngredientData.id);
      ing.ingredientStockId = stockData.id;
      ing.ingredientIngredientTypeId = ingIngType.id;
      ing.highConcentration = parseFloat(highConcentration);
      ing.lowConcentration = parseFloat(lowConcentration);
      ing.weight = parseFloat(weightValue);
      if (isBufferIngredientById(selectIngIngType.ingredientTypeId)) {
        ing.highPhingredientStockId = isNullOrUndefined(highPhStock)
          ? null
          : highPhStock.id;

        ing.highPh = isNullOrUndefined(phStopValue) ? null : parseFloat(phStopValue);
        ing.lowPh = isNullOrUndefined(phStartValue) ? null : parseFloat(phStartValue);
      } else {
        ing.highPhingredientStockId = undefined;
        ing.highPh = undefined;
        ing.lowPh = undefined;
      }
    }
    tempLayer.dirty = true;
    handleBackToPreviousScreen(ELayersView.LAYERDESIGNVIEW)();
    resetStockValue();
  }

  function validateIngredientExists() {
    const ingIngType = GetIngredients().ingredientIngredientType.find(
      (ingingtype) =>
        ingingtype.ingredientId === selectIngIngType.ingredientId &&
        selectIngredientType === ingingtype.ingredientTypeId,
    );
    if (!ingIngType) {
      showAlertSnackBar(
        EAlertType.ERROR,
        ESnackBarPosition.TOP,
        'One or more ingredients no longer exist in database.',
      );
      return;
    }

    return ingIngType;
  }

  function applyIngredient() {
    if (!_selectedLayer) {
      return;
    }

    //Check whether the ingredient still exists in db or not.
    const ingIngType = validateIngredientExists();
    if (!ingIngType) {
      return;
    }

    callPreserveUndoableState();
    const tempLayers = cloneDeep(_layers);
    if (_selectedLayer.type === LayerTypeDTO.Random) {
      applyIngredientInRandomLayer(tempLayers);
    } else {
      applyIngredientData(tempLayers);
    }
    tempLayers.map((lyr) => dirtifyOverLappingLayers(lyr, _selectedLayer, true));
    _setLayers(tempLayers);
    if (setSelectedTab) {
      setSelectedTab(1);
    }
    setHandleOnTabBackPress(null);
  }
  function getIngredientTypes() {
    if (isNullOrUndefined(stockData)) {
      return;
    }
    if (stockData?.isBuffer) {
      const ingType = GetIngredients().ingredientType.filter(
        (ingType) => ingType.isBuffer,
      );
      setIngredientTypes(
        ingType.map((ingtype) => {
          return { name: ingtype.name, value: ingtype.id };
        }),
      );
      setSelectIngredientType(ingType[0]?.id);
    } else {
      const ingingtypes = GetIngredients().ingredientIngredientType.filter(
        (ingingtype) => ingingtype.ingredientId === selectIngIngType.ingredientId,
      );
      const ingType = ingingtypes.map((ingingtype) =>
        GetIngredients().ingredientType.find(
          (ingtype) => ingtype.id === ingingtype.ingredientTypeId,
        ),
      );
      setIngredientTypes(
        ingType
          .filter((i) => !i.isBuffer)
          .map((ingtype) => {
            return { name: ingtype.name, value: ingtype.id };
          }),
      );
      setSelectIngredientType(selectIngIngType.ingredientTypeId);
    }
  }
  function GetConcentrationpHRendererForRandom(lowConc, highConc) {
    if (isNullOrUndefined(stockData)) {
      return;
    }
    return (
      <>
        <>
          <div id="layer-random-concentrationrange-wrapper" className="w-100pr flex">
            <UnitTextBox
              unit={stockData.concentrationUnits}
              labelText="Start"
              inputValue={lowConc}
              onChange={handleLowConcentration}
              error={error}
            />
            <UnitTextBox
              unit={stockData.concentrationUnits}
              labelText="Stop"
              inputValue={highConc}
              onChange={handleHighConcentration}
              error={highConcError}
            />
          </div>
          {isBufferIngredientById(selectIngIngType.ingredientTypeId) &&
            !isNullOrUndefined(stockData?.stockPh) && (
              <>
                <LayersHeading
                  text={`pH ${!isNullOrUndefined(stockData) && stockData.stockPh} - ${
                    !isNullOrUndefined(highPhStock) && highPhStock.stockPh
                  }`}
                />
                <div id="layer-random-phrange-wrapper" className="w-100pr flex">
                  <UnitTextBox
                    unit={stockData.concentrationUnits}
                    labelText="Start"
                    inputValue={phStartValue}
                    onChange={handlephStartValue}
                    error={lowPhError}
                  />
                  <UnitTextBox
                    unit={stockData.concentrationUnits}
                    labelText="Stop"
                    inputValue={phStopValue}
                    onChange={handlephStopValue}
                    error={highPhError}
                  />
                </div>
              </>
            )}
        </>
        <LayersHeading text="Statistics" />
        <div id="layerdesign-random-statistics-wrapper" className="w-100 flex">
          <UnitTextBox
            unit=""
            labelText="Weight"
            inputValue={isNaN(weightValue) ? '' : weightValue}
            onChange={handleWeightValue}
            error={weightError}
          />
        </div>
      </>
    );
  }

  const onEditConcentrationVaryAlongCustomValuesClick = (isOverride = false) => {
    const flag = isOverride.hasOwnProperty('currentTarget')
      ? isConcentrationVaryAlongCustomSpreadSheetEdited
        ? true
        : false
      : isOverride
      ? false
      : true;
    if (flag) {
      setShowOverrideConcentrationVaryAlongCustomSpreadSheetWarning(true);
      return;
    }

    let standardSpreadSheetSize = [];
    const rowLengthOnCanvas = exp.containerRows * exp.rowCount;
    const columnLengthOnCanvas = exp.containerCols * exp.colCount;

    for (let parentIndex = 0; parentIndex < rowLengthOnCanvas; parentIndex++) {
      const innerList = [];
      for (let childIndex = 0; childIndex < columnLengthOnCanvas; childIndex++) {
        innerList.push({ value: '' });
      }
      standardSpreadSheetSize.push(innerList);
    }

    const dataForSpreadSheet = [];
    const gridLayerDetails = _selectedLayer?.layerDetail as GridLayerDTO;

    if (
      !gridLayerDetails?.grid?.gridIngredient ||
      gridLayerDetails?.grid?.gridIngredient?.length != 0
    ) {
      gridLayerDetails.grid.gridIngredient.forEach((ingredient) => {
        if (ingredient.ingredientIngredientTypeId == selectIngredient.id) {
          if (
            ingredient.concentrationVaryAlongCustom &&
            ingredient?.concentrationVaryAlongCustom?.concentrationVaryAlongCustomValues
              ?.length != 0
          ) {
            const concentrationVaryAlongCustomValues =
              ingredient.concentrationVaryAlongCustom.concentrationVaryAlongCustomValues;
            for (
              let parentIndex = 0;
              parentIndex < concentrationVaryAlongCustomValues.length;
              parentIndex++
            ) {
              const innerList = [];
              for (
                let childIndex = 0;
                childIndex < concentrationVaryAlongCustomValues[parentIndex].length;
                childIndex++
              ) {
                try {
                  const concentration =
                    concentrationVaryAlongCustomValues[parentIndex][childIndex];
                  if (!isNullOrUndefined(concentration) || concentration != 0) {
                    standardSpreadSheetSize[parentIndex][childIndex].value =
                      concentration;
                  } else {
                    standardSpreadSheetSize[parentIndex][childIndex].value = '';
                  }
                } catch (error) {
                  console.error(error);
                  standardSpreadSheetSize[parentIndex][childIndex].value = '';
                }
              }
              dataForSpreadSheet.push(innerList);
            }
          } else {
            standardSpreadSheetSize =
              getConcentrationVaryAlongCustomSpreadSheetDataFromWells(
                gridLayerDetails,
                standardSpreadSheetSize,
                dataForSpreadSheet,
              );
          }
        }
      });
    } else {
      standardSpreadSheetSize = getConcentrationVaryAlongCustomSpreadSheetDataFromWells(
        gridLayerDetails,
        standardSpreadSheetSize,
        dataForSpreadSheet,
      );
    }

    setConcentrationVaryAlongCustomSpreadSheetData(standardSpreadSheetSize);
    setShowEditConcentrationVaryAlongCustomValuesModal(true);
  };

  const proceedWithConcentrationVaryAlongCustomSpreadSheetData = (spreadSheetData) => {
    let isFirstNonEmptyValueFound = false;
    const concentrationValues = [];
    for (let parentIndex = spreadSheetData.length - 1; parentIndex >= 0; parentIndex--) {
      const innerList = [];
      for (
        let childIndex = spreadSheetData[parentIndex].length - 1;
        childIndex >= 0;
        childIndex--
      ) {
        const value = spreadSheetData[parentIndex][childIndex].value;
        if (value !== '' && !isFirstNonEmptyValueFound) {
          isFirstNonEmptyValueFound = true;
        }
        if (isFirstNonEmptyValueFound) {
          if (isNullOrUndefined(value) || value === '' || isNaN(value)) {
            innerList.unshift(null);
          } else {
            innerList.unshift(parseFloat(value));
          }
        }
      }
      if (innerList.length > 0) {
        concentrationValues.unshift(innerList);
      }
    }
    setConcentrationVaryAlongCustomValues(concentrationValues);
    setShowEditConcentrationVaryAlongCustomValuesModal(false);
    setIsConcentrationVaryAlongCustomSpreadSheetEdited(true);
  };

  const overridePreviousConcentrationVaryAlongCustomSpreadChanges = () => {
    setShowOverrideConcentrationVaryAlongCustomSpreadSheetWarning(false);
    setIsConcentrationVaryAlongCustomSpreadSheetEdited(false);
    onEditConcentrationVaryAlongCustomValuesClick(true);
  };

  const overridePreviousPhVaryAlongCustomSpreadChanges = () => {
    setShowOverridePhVaryAlongCustomSpreadSheetWarning(false);
    setIsPhVaryAlongCustomSpreadSheetEdited(false);
    onEditPhVaryAlongCustomValuesClick(true);
  };

  function getConcentrationVaryAlongCustomSpreadSheetDataFromWells(
    gridLayerDetails: GridLayerDTO,
    standardSpreadSheetSize: any[],
    dataForSpreadSheet: any[],
  ) {
    const wells: WellIngDTO[][] = findWellsInLayer(
      exp.plateDto,
      _selectedLayer,
      exp.containerRows,
      exp.containerCols,
    );

    wells.forEach((row, parentIndex) => {
      const innerList = [];
      row.forEach((well, childIndex) => {
        well.wellLayerList.forEach((wellLayer) => {
          if (wellLayer.layerId == _selectedLayerId) {
            if (wellLayer.wellLayerIngredientList.length == 0) {
              standardSpreadSheetSize[parentIndex][childIndex].value = 0;
              return;
            }
            wellLayer.wellLayerIngredientList.forEach((wellLayerIngredient) => {
              if (wellLayerIngredient.ingredientIngredientTypeId == selectIngredient.id) {
                standardSpreadSheetSize[parentIndex][childIndex].value =
                  wellLayerIngredient.concentration;
              }
            });
          }
        });
      });
      dataForSpreadSheet.push(innerList);
    });
    return standardSpreadSheetSize;
  }

  function getPhVaryAlongCustomSpreadSheetDataFromWells(
    gridLayerDetails: GridLayerDTO,
    standardSpreadSheetSize: any[],
    dataForSpreadSheet: any[],
  ) {
    const wells: WellIngDTO[][] = findWellsInLayer(
      exp.plateDto,
      _selectedLayer,
      exp.containerRows,
      exp.containerCols,
    );

    wells.forEach((row, parentIndex) => {
      const innerList = [];
      row.forEach((well, childIndex) => {
        well.wellLayerList.forEach((wellLayer) => {
          if (wellLayer.layerId == _selectedLayerId) {
            if (wellLayer.wellLayerIngredientList.length == 0) {
              standardSpreadSheetSize[parentIndex][childIndex].value = 0;
              return;
            }
            wellLayer.wellLayerIngredientList.forEach((wellLayerIngredient) => {
              if (wellLayerIngredient.ingredientIngredientTypeId == selectIngredient.id) {
                standardSpreadSheetSize[parentIndex][childIndex].value =
                  wellLayerIngredient.pH;
              }
            });
          }
        });
      });
      dataForSpreadSheet.push(innerList);
    });
    return standardSpreadSheetSize;
  }

  const onEditPhVaryAlongCustomValuesClick = (isOverride = false) => {
    const flag = isOverride.hasOwnProperty('currentTarget')
      ? isPhVaryAlongCustomSpreadSheetEdited
        ? true
        : false
      : isOverride
      ? false
      : true;
    if (flag) {
      setShowOverridePhVaryAlongCustomSpreadSheetWarning(true);
      return;
    }

    let standardSpreadSheetSize = [];
    const rowLengthOnCanvas = exp.containerRows * exp.rowCount;
    const columnLengthOnCanvas = exp.containerCols * exp.colCount;

    for (let parentIndex = 0; parentIndex < rowLengthOnCanvas; parentIndex++) {
      const innerList = [];
      for (let childIndex = 0; childIndex < columnLengthOnCanvas; childIndex++) {
        innerList.push({ value: '' });
      }
      standardSpreadSheetSize.push(innerList);
    }

    const dataForSpreadSheet = [];
    const gridLayerDetails = _selectedLayer.layerDetail as GridLayerDTO;

    if (
      !gridLayerDetails?.grid?.gridIngredient ||
      gridLayerDetails?.grid?.gridIngredient?.length != 0
    ) {
      gridLayerDetails.grid.gridIngredient.forEach((ingredient) => {
        if (ingredient.ingredientIngredientTypeId == selectIngredient.id) {
          if (
            ingredient.pHVaryAlongCustom &&
            ingredient?.pHVaryAlongCustom?.pHVaryAlongCustomValues?.length != 0
          ) {
            const phVaryAlongCustomValues =
              ingredient?.pHVaryAlongCustom?.pHVaryAlongCustomValues;
            for (
              let parentIndex = 0;
              parentIndex < phVaryAlongCustomValues.length;
              parentIndex++
            ) {
              const innerList = [];
              for (
                let childIndex = 0;
                childIndex < phVaryAlongCustomValues[parentIndex].length;
                childIndex++
              ) {
                try {
                  const concentration = phVaryAlongCustomValues[parentIndex][childIndex];
                  if (!isNullOrUndefined(concentration) || concentration != 0) {
                    standardSpreadSheetSize[parentIndex][childIndex].value =
                      concentration;
                  } else {
                    standardSpreadSheetSize[parentIndex][childIndex].value = '';
                  }
                } catch (error) {
                  console.error(error);
                  standardSpreadSheetSize[parentIndex][childIndex].value = '';
                }
              }
              dataForSpreadSheet.push(innerList);
            }
          } else {
            standardSpreadSheetSize = getPhVaryAlongCustomSpreadSheetDataFromWells(
              gridLayerDetails,
              standardSpreadSheetSize,
              dataForSpreadSheet,
            );
          }
        }
      });
    } else {
      standardSpreadSheetSize = getPhVaryAlongCustomSpreadSheetDataFromWells(
        gridLayerDetails,
        standardSpreadSheetSize,
        dataForSpreadSheet,
      );
    }
    setPhVaryAlongCustomSpreadSheetData(standardSpreadSheetSize);
    setShowEditPhVaryAlongCustomValuesModal(true);
  };

  const proceedWithPhVaryAlongCustomSpreadSheetData = (spreadSheetData) => {
    let isFirstNonEmptyValueFound = false;
    const pHValues = [];
    for (let parentIndex = spreadSheetData.length - 1; parentIndex >= 0; parentIndex--) {
      const innerList = [];
      for (
        let childIndex = spreadSheetData[parentIndex].length - 1;
        childIndex >= 0;
        childIndex--
      ) {
        const value = spreadSheetData[parentIndex][childIndex].value;
        if (value !== '' && !isFirstNonEmptyValueFound) {
          isFirstNonEmptyValueFound = true;
        }
        if (isFirstNonEmptyValueFound) {
          if (isNullOrUndefined(value) || value === '' || isNaN(value)) {
            innerList.unshift(null);
          } else {
            innerList.unshift(parseFloat(value));
          }
        }
      }
      if (innerList.length > 0) {
        pHValues.unshift(innerList);
      }
    }

    setPhVaryAlongCustomValues(pHValues);
    setShowEditPhVaryAlongCustomValuesModal(false);
    setIsPhVaryAlongCustomSpreadSheetEdited(true);
  };

  const stopKeyboardEventBubble = (e: any) => {
    e.stopPropagation();
  };

  return (
    <>
      <RMModal
        id="commandpanel-editing-overrideconcetration-modal"
        showModal={showOverrideConcentrationVaryAlongCustomSpreadSheetWarning}
        setShowModal={setShowOverrideConcentrationVaryAlongCustomSpreadSheetWarning}
        onOk={overridePreviousConcentrationVaryAlongCustomSpreadChanges}
        body={
          'Please save changes otherwise spread sheet data will be overridden by the previously saved values.'
        }
        heading={'Warning'}
      />
      <RMModal
        id="commandpanel-editing-overrideph-modal"
        showModal={showOverridePhVaryAlongCustomSpreadSheetWarning}
        setShowModal={setShowOverridePhVaryAlongCustomSpreadSheetWarning}
        onOk={overridePreviousPhVaryAlongCustomSpreadChanges}
        body={
          'Please save changes otherwise spread sheet data will be overridden by the previously saved values.'
        }
        heading={'Warning'}
      />
      <RMModal
        id="commandpanel-editing-editconcentration-modal"
        showModal={showEditConcentrationVaryAlongCustomValuesModal}
        setShowModal={setShowEditConcentrationVaryAlongCustomValuesModal}
        onOk={() =>
          proceedWithConcentrationVaryAlongCustomSpreadSheetData(
            concentrationVaryAlongCustomSpreadSheetData,
          )
        }
        body={
          <div
            id="commandpanel-editing-editconcentration-spreedsheet"
            style={{ overflow: 'scroll', height: '60vh' }}
          >
            <Spreadsheet
              data={concentrationVaryAlongCustomSpreadSheetData}
              onChange={setConcentrationVaryAlongCustomSpreadSheetData}
              onKeyDown={stopKeyboardEventBubble}
            />
          </div>
        }
        heading="Edit Custom Values"
        dialogClassName="grid-layer-custom-spreadsheet"
      />
      <RMModal
        id="commandpanel-editing-editph-modal"
        showModal={showEditPhVaryAlongCustomValuesModal}
        setShowModal={setShowEditPhVaryAlongCustomValuesModal}
        onOk={() =>
          proceedWithPhVaryAlongCustomSpreadSheetData(phVaryAlongCustomSpreadSheetData)
        }
        body={
          <div
            id="commandpanel-editing-editph-spreedsheet"
            style={{ overflow: 'scroll', height: '60vh' }}
          >
            <Spreadsheet
              data={phVaryAlongCustomSpreadSheetData}
              onChange={setPhVaryAlongCustomSpreadSheetData}
              onKeyDown={stopKeyboardEventBubble}
            />
          </div>
        }
        heading="Edit Custom Values"
        dialogClassName="grid-layer-custom-spreadsheet"
      />
      <div id="commandpanel-editing-content-wrapper" style={{ margin: '0 4.364%' }}>
        <EICheckBox
          labelText="Name"
          textBoxText={ingredientName}
          active={ingredientName === ELayersDefaultInput.SELECTINGREDIENT}
          onClick={() => setContentView(ELayersView.SELECTINGREDIENTSVIEW)}
        />
        {stockData?.isBuffer && stockData?.stockPh ? (
          <>
            <EICheckBox
              labelText="Low pH"
              textBoxText={
                isNullOrUndefined(stockData)
                  ? ELayersDefaultInput.SELECTSTOCKS
                  : getStockConcVendor(stockData, true)
              }
              active={isNullOrUndefined(stockData)}
              onClick={onSelectStock}
            />
            <EICheckBox
              labelText="High pH"
              textBoxText={
                isNullOrUndefined(highPhStock)
                  ? ELayersDefaultInput.SELECTHIGHPHSTOCK
                  : getStockConcVendor(highPhStock, true)
              }
              active={isNullOrUndefined(highPhStock)}
              onClick={() => setContentView(ELayersView.HIGHPHVIEW)}
              isShowClose
              onClose={() => setHighPhStock(null)}
            />
          </>
        ) : (
          <EICheckBox
            labelText="Stock"
            textBoxText={
              isNullOrUndefined(stockData)
                ? ELayersDefaultInput.SELECTSTOCKS
                : getStockConcVendor(stockData, true)
            }
            onClick={onSelectStock}
          />
        )}
        <EISelectBox
          placeholder="Select Ingredient Type"
          labelText="Type"
          selectedValue={selectIngredientType}
          onChange={changeIngredientType}
          options={ingredientTypes}
          disabled={ingredientTypes.length <= 1}
        />

        {}
        <LayersHeading text="Concentration" className="ml-[2%]" />
        {_selectedLayer?.type == LayerTypeDTO.Grid ? (
          <>
            <EISelectBox
              labelText="Vary Along"
              selectedValue={concentrationVaryAlong}
              onChange={changeConcentrationVaryAlong}
              options={gridVaryAlong}
              containerClassName="w-[98%] ml-[2%]"
              labelClassName="w-[18%]"
              selectClassName="w-[82%]"
            />
            {showConcentrationVaryAlongCustomButton && (
              <div
                id="commandpanel-editing-btn-editcustomconcentration-wrapper"
                style={{
                  marginTop: '5px',
                  marginLeft: '20%',
                }}
              >
                <RMButton
                  id="commandpanel-editing-btn-editcustomconcentration"
                  onClick={onEditConcentrationVaryAlongCustomValuesClick}
                  label={'Edit Custom Values'}
                  type={FmlxButton.Type.POSITIVE}
                ></RMButton>
              </div>
            )}
            {concentrationVaryAlong !== EGridVaryAlong.CUSTOM && (
              <div
                id="commandpanel-editing-concentration-inputs-wrapper"
                className="w-100pr flex ml-[2%] w-[98%]"
              >
                <UnitTextBox
                  unit={stockData && stockData.concentrationUnits}
                  labelText="Start"
                  inputValue={startConcentration}
                  onChange={handleStartConcentration}
                  error={error}
                  labelClassName="w-[36%]"
                  containerClassName=" w-[50%] justify-start"
                  inputDivClassName="pl-0 ml-0 w-[40%]"
                  unitClassName="w-[10%] pl-0"
                />
                {concentrationVaryAlong !== EGridVaryAlong.NONE && (
                  <UnitTextBox
                    unit={stockData && stockData.concentrationUnits}
                    labelText="Stop"
                    inputValue={stopConcentration}
                    onChange={handleStopConcentration}
                    error={highConcError}
                    labelClassName="w-[36%]"
                    containerClassName=" w-[50%] justify-start"
                    inputDivClassName="pl-0 ml-0 w-[40%]"
                    unitClassName="w-[10%] pl-0"
                  />
                )}
              </div>
            )}
          </>
        ) : _selectedLayer?.type === LayerTypeDTO.ConditionList ? (
          <UnitTextBox
            unit={stockData && stockData.concentrationUnits}
            labelText="Start"
            inputValue={customLayerConcentration}
            onChange={handleCustomLayerConcentration}
            error={error}
          />
        ) : (
          GetConcentrationpHRendererForRandom(lowConcentration, highConcentration)
        )}
        {}
        {stockData?.isBuffer &&
          !isNullOrUndefined(stockData?.stockPh) &&
          _selectedLayer?.type !== LayerTypeDTO.Random && (
            <>
              <LayersHeading
                text={`pH ${
                  !isNullOrUndefined(stockData) ? stockData.stockPh : 'N/A'
                } - ${!isNullOrUndefined(highPhStock) ? highPhStock.stockPh : 'N/A'}`}
              />
              {_selectedLayer?.type === LayerTypeDTO.Grid && (
                <EISelectBox
                  labelText="Vary Along"
                  selectedValue={phVaryAlong}
                  onChange={changepHVaryAlong}
                  options={gridVaryAlong}
                  containerClassName="w-[98%] ml-[2%]"
                  labelClassName="w-[18%]"
                  selectClassName="w-[82%]"
                />
              )}
              {showPhVaryAlongCustomButton && (
                <div
                  id="commandpanel-editing-btn-editcustomph-wrapper"
                  style={{
                    display: 'flow-root',
                    float: 'right',
                    width: '21.125vw',
                    marginTop: '5px',
                    fontSize: '1.1vw',
                  }}
                >
                  <RMButton
                    id="commandpanel-editing-btn-editcustomph"
                    onClick={onEditPhVaryAlongCustomValuesClick}
                    label={'Edit Custom Values'}
                    type={FmlxButton.Type.POSITIVE}
                  ></RMButton>
                </div>
              )}
              {phVaryAlong !== EGridVaryAlong.CUSTOM && (
                <div
                  id="commandpanel-editing-ph-inputs-wrapper"
                  className="w-100pr flex ml-[2%] w-[98%]"
                >
                  {_selectedLayer?.type == LayerTypeDTO.Grid ? (
                    <>
                      <UnitTextBox
                        unit=""
                        labelText="Start"
                        inputValue={phStartValue}
                        onChange={handlephStartValue}
                        error={lowPhError}
                        labelClassName="w-[36%]"
                        containerClassName=" w-[50%] justify-start"
                        inputDivClassName="pl-0 ml-0 w-[40%]"
                        unitClassName="w-[10%] pl-0"
                      />
                      {phVaryAlong !== EGridVaryAlong.NONE && highPhStock && (
                        <UnitTextBox
                          unit=""
                          labelText="Stop"
                          inputValue={phStopValue}
                          onChange={handlephStopValue}
                          error={highPhError}
                          labelClassName="w-[36%]"
                          containerClassName=" w-[50%] justify-start"
                          inputDivClassName="pl-0 ml-0 w-[40%]"
                          unitClassName="w-[10%] pl-0"
                        />
                      )}
                    </>
                  ) : (
                    <UnitTextBox
                      unit=""
                      labelText="Start"
                      inputValue={customPhValue}
                      onChange={handleCustomPhValue}
                      error={lowPhError}
                    />
                  )}
                </div>
              )}
            </>
          )}
        {isEditIngError() && (
          <LayersError
            errorText="Some of the data you entered is invalid"
            style={{ marginTop: '1rem' }}
          />
        )}
      </div>
      <div
        id="commandpanel-editing-applybtn-wrapper"
        className="flex w-[100%]"
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginTop: '5px',
          paddingRight: '4%',
        }}
      >
        <RMButton
          id="commandpanel-editing-btn-apply"
          disabled={isEditIngError()}
          onClick={applyIngredient}
          label={'Apply'}
          type={FmlxButton.Type.POSITIVE}
        ></RMButton>
      </div>
    </>
  );
}

export default withTabBackButton(EditIngredients);
